"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollapsibleContent;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@site/utils");
function CollapsibleContent({
  CelebrateDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
  PremiumDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
  SpinInCartExpandedComponent = () => /*#__PURE__*/_react.default.createElement("div", null),
  domain,
  isDomainInCart,
  hideDetailedViewExactMatch,
  onExpandedSpinDataNotAvailable,
  SpinsCardRecommendationsComponent,
  showMoreLikeThisOption,
  showMoreLikeThisDomains,
  isSpinExpandable = false
}) {
  const isAftermarketPremiumDomain = (0, _utils.isAftermarketPremium)(domain);
  const isRegPremiumDomain = (0, _utils.isRegPremium)(domain);
  const isAuctionDomain = (0, _utils.isAuction)(domain);
  const getInfoTextId = () => {
    if (isRegPremiumDomain) {
      return 'domain.available.info.premium';
    } else if (isAftermarketPremiumDomain) {
      return 'domain.available.info.buyItNow';
    } else if (isAuctionDomain) {
      return (0, _utils.getAuctionInfo)(domain?.AuctionTypeId).infoTextId;
    }
    return '';
  };
  if (isSpinExpandable && isDomainInCart) {
    return /*#__PURE__*/_react.default.createElement(SpinInCartExpandedComponent, {
      domain: domain.Fqdn,
      onDataNotAvailable: onExpandedSpinDataNotAvailable,
      isSpinExpandable: isSpinExpandable
    });
  }
  if (showMoreLikeThisOption && showMoreLikeThisDomains) {
    return /*#__PURE__*/_react.default.cloneElement(SpinsCardRecommendationsComponent, {
      domainToCheck: domain?.Fqdn
    });
  }
  if (isAftermarketPremiumDomain || isRegPremiumDomain || isAuctionDomain) {
    return /*#__PURE__*/_react.default.createElement(PremiumDetailView, {
      spinDomain: domain,
      isAfterMarketDomain: true,
      isAftermarketPremiumDomain: isAftermarketPremiumDomain,
      isRegPremiumDomain: isRegPremiumDomain,
      isAuctionDomain: isAuctionDomain,
      infoTextId: getInfoTextId(),
      isSpinDetailView: true,
      hideExactMatch: hideDetailedViewExactMatch
    });
  }
  return /*#__PURE__*/_react.default.createElement(CelebrateDetailView, {
    domain: domain,
    product: domain.product,
    hideExactMatch: hideDetailedViewExactMatch
  });
}
CollapsibleContent.propTypes = {
  CelebrateDetailView: _propTypes.default.func,
  PremiumDetailView: _propTypes.default.func,
  SpinInCartExpandedComponent: _propTypes.default.func,
  isDomainInCart: _propTypes.default.bool,
  hideDetailedViewExactMatch: _propTypes.default.bool,
  onExpandedSpinDataNotAvailable: _propTypes.default.func,
  isSpinExpandable: _propTypes.default.bool,
  showMoreLikeThisOption: _propTypes.default.bool,
  SpinsCardRecommendationsComponent: _propTypes.default.node,
  showMoreLikeThisDomains: _propTypes.default.bool,
  domain: _propTypes.default.shape({
    product: _propTypes.default.shape(),
    Fqdn: _propTypes.default.string,
    AuctionTypeId: _propTypes.default.number
  })
};